import fetch from 'isomorphic-fetch';
import config from './config';
import Cookie from 'js-cookie';

export const requestOptions = method => ({
  method,
  headers: { ...config.headers },
});

export const toJSON = r => r.json();

export function getOrderInfo(token) {
  const URL = `${config.authEndPoint}/purchase_orders/${token}`;
  const opt = {
    ...requestOptions('GET'),
  };

  return fetch(URL, opt)
    .then(r => r.json())
    .then(payload => (payload.error ? Promise.reject(payload) : Promise.resolve(payload)));
}

export function createOrder(params) {
  console.log('params', params);
  const URL = `${config.authEndPoint}/opt_in/purchase_orders/create-draft`;
  const opt = {
    ...requestOptions('POST'),
    body: JSON.stringify(params),
  };

  if (params.token) {
    opt.headers['X-Auth-Token'] = params.token;
  }

  return fetch(URL, opt)
    .then(r => r.json())
    .then(payload => (payload.error ? Promise.reject(payload) : Promise.resolve(payload)));
}

export function updateOrder(token, params) {
  const URL = `${config.authEndPoint}/purchase_orders/${token}`;

  const opt = {
    ...requestOptions('PUT'),
    body: JSON.stringify(params),
  };

  return fetch(URL, opt)
    .then(r => r.json())
    .then(payload => (payload.error ? Promise.reject(payload) : Promise.resolve(payload)));
}

export function finalizeOrderCreate(token) {
  const URL = `${config.authEndPoint}/purchase_orders/${token}/finish`;
  const awc_token = Cookie.get('awc');
  const opt = {
    ...requestOptions('POST'),
    body: JSON.stringify(awc_token ? {'awc_token': awc_token} : {}),
  };
  

  return fetch(URL, opt)
    .then(r => r.json())
    .then(payload => (payload.error ? Promise.reject(payload) : Promise.resolve(payload)));
}

export function getRedirectUrl(token) {
  const URL = `${config.authEndPoint}/purchase_orders/${token}/submit`;
  const opt = {
    ...requestOptions('POST'),
  };

  return fetch(URL, opt)
    .then(r => r.json())
    .then(payload => (payload.error ? Promise.reject(payload) : Promise.resolve(payload)));
}

export function getCarDetails(carID) {
  const URL = `${config.authEndPoint}/cars/${carID}`;
  const opt = { method: 'GET' };

  return fetch(URL, opt)
    .then(r => r.json())
    .then(payload => (payload.error ? Promise.reject(payload) : Promise.resolve(payload)));
}

export function sendContactForm(id, params) {
  const URL = `${config.authEndPoint}/cars/${id}/finance`;
  const opt = {
    ...requestOptions('POST'),
    body: JSON.stringify(params),
  };

  return fetch(URL, opt)
    .then(r => r.json())
    .then(payload => (payload.error ? Promise.reject(payload) : Promise.resolve(payload)));
}
